import { Utente } from 'src/app/shared/models/utente.model';
import { RoleType } from 'src/app/shared/models/role-type.model';
import { ResourceType } from 'src/app/shared/models/resource-type.model';
import { GlossaryType } from 'src/app/shared/models/glossary-type.model';
import { Resource } from 'src/app/shared/models/resource.model';
import { NoteType } from 'src/app/shared/models/note-type.model';
import { AttachmentType } from 'src/app/shared/models/attachment-type.model';

/** Interfaccia che rappresenta lo stato a livello di autenticazione */
export interface State {
    /**Se l'utente è autenticato */
    isAuth: boolean;
    /**Dati dell'utente loggato */
    loggedUser: Utente;
    /**Note personali */
    notePersonali: string;
    /**Elenco delle risorse assegnate a un utente */
    assignedResources: Resource[];
    /**Messagio di errore in autenticazione */
    authError: string;
    /**Booleano di warning */
    isWarning: boolean;
    /**Elenco delle tipologie di ruolo */
    roleTypeList: RoleType[];
    /**Elenco delle tipologie di risorsa */
    resourceTypeList: ResourceType[];
    /**Se siamo in fase di caricamento dati o meno */
    isLoading: boolean;
    /**Elenco delle tipologie di glossario */
    glossaryTypeList: GlossaryType[];
    /**Elenco delle tipologie di nota */
    noteTypeList: NoteType[]; 
    /**Elenco delle tipologie di allegato */
    attachmentTypeList: AttachmentType[];
}

/**Stato iniziale per la parte di autenticazione */
export const initialState: State = {} as State;